class ShadesVote extends HTMLElement {
  constructor() {
      super();
  }

  connectedCallback() {
    console.log('Shades Vote Added');
    this.init();
  }


  init(){

    let self = this;
    
    let buttons = document.querySelectorAll('.vote-block button[data-type]');

    buttons.forEach(function(button){
      button.addEventListener('click', function(){
        self.buttonsLock();
        self.submitVote(button.dataset.type);
      })
    });
    
    console.log('Shades vote Init complete.')

    if(this.getCookie('shades-vote')) {
      this.switchPage('results');
    }
    
  }

  switchPage(pageName){
    let pages = this.querySelectorAll('[data-page]');
    pages.forEach(function(page){
      page.removeAttribute('data-active');
      page.classList.remove('active');
      if(page.dataset.page == pageName) {
        page.dataset.active = '';
        setTimeout(() => {            
          page.classList.add('active');
        }, 100);
        
      }
    });
  }

  generateUUID() {
      var d = new Date().getTime();
      var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;
        if(d > 0){
            r = (d + r)%16 | 0;
            d = Math.floor(d/16);
        } else {
            r = (d2 + r)%16 | 0;
            d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  getUUID(){
   
    let cookie = this.getCookie('shades-vote');
    if(!cookie) {
      let uuid = this.generateUUID();
      this.setCookie('shades-vote',uuid,1);
      return uuid;
    }
    return cookie;
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  buttonsLock(){
    let buttons = document.querySelectorAll('.vote-block button[data-type]');
    buttons.forEach(function(button){
      button.disabled = true;
    });
  }

  submitVote(type) {
    let uuid = this.getUUID();
    console.log('VOTE ATTEMPT: ' + type + ', UUID: ' + uuid);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    
    const raw = JSON.stringify({
      "uid": "" + uuid,
      "vote": "" + type
    });
    
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };
    
    fetch("https://shades.weareshift.agency/api/vote/register", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        this.switchPage('results');
        console.log(result);
      })
      .catch((error) => {
        this.switchPage('results');
        console.error(error);
      });
  }
}
customElements.define("shades-vote", ShadesVote);


class ShadesVoteShower extends HTMLElement {
  constructor() {
      super();
  }

  connectedCallback() {
    console.log('Shades Vote Shower Added');
    this.init();
  }

  init(){
    let self = this;
    document.addEventListener("DOMContentLoaded", (event) => {
      if(!self.getCookie('shades-leaderboardhidden')){
        let voteShower = self.querySelector('#voteshower-display');
        voteShower.checked = true
        voteShower.getBoundingClientRect();
        voteShower.addEventListener("click", (event) => {
          console.log('set cookie ' + (event.target.checked ? 0 : 1))
          self.setCookie('shades-leaderboardhidden', true, (event.target.checked ? 0 : 1));
        })
      }
      
      let showerLinks = document.querySelectorAll("a[href*='#leaderboard']");
      showerLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          document.querySelector('#shades-vote').checked = true;
        });
      });
    });     
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

}
customElements.define("shades-voteshower", ShadesVoteShower);